import gql from 'graphql-tag'

export const allTiles = gql`query allTiles($before: String
  $after: String
  $first: Int
  $last: Int
	$sku: String
  $sku_Icontains: String
  $sku_Istartswith: String
  $sku_In: String
  $imageFirst: Int
) {
  allTiles(before: $before, after: $after, first: $first, last: $last, sku: $sku,
  sku_Icontains: $sku_Icontains, sku_Istartswith: $sku_Istartswith, sku_In: $sku_In, excludeCutSample:true) {
    edges {
      node {
        id
        sku
        subname
        description
        series {
          id
          name
          code
          slug
          category
          tagline
          description
          users
        }
        shape {
          id
          name
          code
          width
          height
          size
          shapeSearch
          description
          trim
          trimType
          mosaic
          decoratives
          display
          position
        }
        color {
          id
          name
          code
          family
          shadeVariation
        }
        look
        users
        type
        thickness
        application
        finish
        edge
        countryOfOrigin
        microban
        slipResistance
        bodyComposition
        recycledContent
        unavailableForSampleOrder
        tileImages(first: $imageFirst) {
          edges {
            node {
              id
              type
              originalImage
              publicThumbnail
              squareImage
              largeImage
              largerImage
            }
          }
        }
        shadeImage	
        seriesUrl
        scenes {
          edges {
            node {
              id
              cardImage
              thumbnail
              sliderImage
              sliderLoading
              largeImage
            }
          }
        }
      }
    }
  }
}`

export const searchTiles = gql`query searchTiles($before: String
  $after: String
  $first: Int
  $last: Int
  $filter: GrapheneElasticFilterTileSearchConnectionBackendFilter
  $search: GrapheneElasticSearchTileSearchConnectionBackendFilter
  $ordering: GrapheneElasticOrderingTileSearchConnectionBackendFilter) {
    searchTiles(before: $before, after: $after, first: $first, last: $last, filter: $filter, search: $search, ordering: $ordering) {
      edges {
        cursor
        node {
          id
          sampleId
          sku
          seriesName
          users
          shadeVariation
          countryOfOrigin
          microban
          shape
          color
          squareImage
          series
          interiorDesignStyle
          unavailableForSampleOrder
          application
          look
          type
          edge
          finish
          thickness
          seriesUrl
          originalImage
          publicThumbnail
          addDropShadow
          isMosaic
          isTrim
          isDecorative
        }
      }
      pageInfo {
        hasPreviousPage
        hasNextPage
        startCursor
        endCursor
      }
    }
}`

export const searchColors = gql`query searchColors($before: String
  $after: String
  $first: Int
  $last: Int
  $filter: GrapheneElasticFilterColorSearchConnectionBackendFilter
  $ordering: GrapheneElasticOrderingColorSearchConnectionBackendFilter) {
    searchColors(before: $before, after: $after, first: $first, last: $last, filter: $filter, ordering: $ordering) {
      edges {
        cursor
        node {
          id
          tileId
          sampleId
          sku
          seriesName
          users
          shadeVariation
          countriesOfOrigin
          hasMicroban
          shape
          name
          code
          mosaicSizes
          family
          squareImages
          series
          sizeDesc
          sizes
          mosaics
          trims
          onlyTrims
          onlyDecoratives
          onlyMosaics
          mosaicImages
          interiorDesignStyle
          applications
          looks
          types
          edges
          finishes
          thicknesses
          decoratives
          shapes
          seriesUrl
          originalImages
          publicThumbnails
          addDropShadow
          hasMosaic
          hasTrim
          hasDecorative
        }
      }
      pageInfo {
        hasPreviousPage
        hasNextPage
        startCursor
        endCursor
      }
    }
}`

export const getTile = gql`query getTile ($id: ID!) {
  tile(id: $id) {
    id
    sampleId
    sku
    series {
      id
      name
      category
      literaturePdf
      ecoScoreCardLink
      rectified
      videoUrl
      videoEmbedUrl
      videoYoutubeId
      videoPosterImage
    }
    color {
      id
      name
      code
    }
    tileImages{
      edges {
        node {
          id
          type
          position
          publicThumbnail
          largeImage
          largerImage
          addDropShadow
        }
      }
    }
    shape {
      id
    	name
      size
      trimType
      width
      height
      mosaic
      decoratives
      code
    }
    edge
    subname
    look
    users
    microban
    thickness
    application
    unavailableForSampleOrder
    bodyComposition
    shadeImage
    type
    finish
    recycledContent
    seriesUrl
    scenes {
      edges {
        node {
          id
          originalImage
          cardImage
          thumbnail
          largeImage
        }
      }
    }
  }
}`

export const tileFilters = gql`query tileFilters {
  tileFilters {
    look
    type
    color
    size
    series {
      id
      category
      name
    }
    shape
    decoratives
    trim
    mosaics
    application
    finish
    edge
    shade
    shadeSeries
    country
    interior
  }
}`

export const homePageSeries = gql`query ($inHomepageSliderResidential: Boolean, $inHomepageSliderCommercial: Boolean) {
  allSeries(inHomepageSliderCommercial: $inHomepageSliderCommercial, inHomepageSliderResidential: $inHomepageSliderResidential) {
    edges {
      node {
        id
        category
        name
        code
        sliderText
        url
        videoEmbedUrl
        videoUrl
        bodyComposition
        literaturePdf
        seoDescription
        roomScenes {
          edges {
            node {
              tiles {
                edges {
                  node {
                    sku
                  }
                }
              }
              sliderImage
              sliderLoading
              position
              thumbnail
              featuredCommercial
              featuredResidential
              featuredColor {
                name
                id
                code
                family
              }
            }
          }
        }
      }
    }
  }
}`

export const searchSeries = gql`query searchSeries($before: String
  $after: String
  $first: Int
  $last: Int
  $filter: GrapheneElasticFilterSeriesSearchConnectionBackendFilter
  $search: GrapheneElasticSearchSeriesSearchConnectionBackendFilter
  $ordering: GrapheneElasticOrderingSeriesSearchConnectionBackendFilter) {
    searchSeries(before: $before, after: $after, first: $first, last: $last, filter: $filter, search: $search, ordering: $ordering) {
      edges {
        cursor
        node {
          id
          name
          category
          tagline
          url
          image
          bodyComposition
          shadeVariation
          interiorDesignStyle
          types
          looks
          microban
          madeInUsa
          mosaics
          trims
          finishes
          edges
        }
      }
      pageInfo {
        hasNextPage
        startCursor
        endCursor
      }
    }
}`

export const searchPages = gql`query searchPages($before: String
  $after: String
  $first: Int
  $last: Int
  $filter: GrapheneElasticFilterPageSearchConnectionBackendFilter
  $search: GrapheneElasticSearchPageSearchConnectionBackendFilter
  $ordering: GrapheneElasticOrderingPageSearchConnectionBackendFilter) {
    searchPages(before: $before, after: $after, first: $first, last: $last, filter: $filter, search: $search, ordering: $ordering) {
      edges {
        cursor
        node {
          title
          url
          description
        }
      }
      pageInfo {
        hasNextPage
        startCursor
        endCursor
      }
    }
}`

export const searchLocations = gql`query searchLocations($before: String
  $after: String,
  $first: Int,
  $last: Int, 
  $latitude: Float!,
  $longitude: Float!,
  $miles: Int!
	$locationTypes: [String]!) {
  searchLocations(before: $before, after: $after, first: $first, last: $last, latitude: $latitude, longitude: $longitude, miles: $miles, locationTypes: $locationTypes) {
    edges {
      node {
        id
        name
        dealerId
        address
        city
        state
        zipCode
        country
        phone
        point
        fullAddress
        website
        locationType
        distance
			}
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
  }
}`

export const roomSceneGallery = gql`query($filter: GrapheneElasticFilterSceneSearchConnectionBackendFilter, $first: Int, $last: Int,$after: String, $before: String){
  searchScenes(first: $first,last: $last, after: $after,before: $before, filter:$filter){
    edges{
      cursor
      node{
        id
        description
        trend
        residential
        commercial
        mosaics
        lightboxDescription
        cardImage
        largeImage
        sliderImage
        tiles
        series
        originalImage
        description
      }
    }
  	pageInfo {
  		hasNextPage
  		hasPreviousPage
  		startCursor
  		endCursor
    }
  }
}`

export const projectGallery = gql`query($filter: GrapheneElasticFilterProjectSearchConnectionBackendFilter, $first: Int, $last: Int,$after: String, $before: String){
  searchProjects(first: $first,last: $last, after: $after,before: $before, filter:$filter){
    edges{
      cursor
      node{
        id
        description
        residential
        commercial
        categoryName
        subcategory
        largeImage
        sliderImage
        cardImage
        gallery
        seriesInImage
        shapesInImage
        colorsInImage

      }
    }
  	pageInfo {
  		hasNextPage
  		hasPreviousPage
  		startCursor
  		endCursor
    }
  }
}`

 export const bookmarkedTiles = gql `query bookmarkedTiles($before: String
  $after: String
  $first: Int
  $last: Int
	$id: [ID]!
) {
  allTiles(before: $before, after: $after, first: $first, last: $last, id: $id) {
    edges {
      node {
        id
        sku
        series {
          id
          name
          category
        }
        color {
          name
          id
        }
        tileImages(first: 1) {
          edges {
            node {
              id
              type
              squareImage
              addDropShadow
            }
          }
        }
        shape {
          id
          name
          size
          code
        }
      }
    }
  }
}`

export const tilesForColor = gql `query tilesForColor($id: [ID]!, $unavailableForSampleOrder: Boolean, $excludeCutSample: Boolean) {
  allColors (id:$id) {
    edges {
      node {
        id
        tiles(unavailableForSampleOrder:$unavailableForSampleOrder, excludeCutSample:$excludeCutSample) {
          edges {
            node {
              id
              shadeImage
              sku
              series {
                id
                name
                category
              }
              color {
                id
              }
              tileImages(first: 1) {
                edges {
                  node {
                    id
                    type
                    squareImage
                    largerImage
                    largeImage
                    publicThumbnail
                    addDropShadow
                  }
                }
              }
              shape {
                id
                mosaic
                position
                name
                trimType
                decoratives
                size
                code
              }
            }
          }
        }
      }
    }
  }
}`

export const allCommercialScenes = gql `query allCommercialSpaces{
  allCommercialSpaces{
    edges{
      node{
        featuredImage
        descriptionHeadline
        description
        category
        scenes{
          edges{
            node{
              location
              originalImage
              seriesInImage
              shapesInImage
              colorsInImage
            }
          }
        }

      }
    }
  }
}`


// WEBPACK FOOTER //
// ./core/vue/graphql/queries.js